export default "__VITE_ASSET__syi_hd2a__";